var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companies-list-page fixed-draggable-dynamic-table-wrapper-height"},[_c('draggable-dynamic-table',{attrs:{"columns":_vm.columnsLabel,"data":_vm.data,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }